<div class="message-container" [style.display]="!show ? 'none' : 'flex'">
  <span class="message">{{ 'request_push.title' | translate }}</span>
  <span class="question">{{ 'request_push.message' | translate }}</span>
  <div style="display: flex; gap: 10px">
    <a (click)="close()">{{ 'request_push.later' | translate }}</a>  
    <a (click)="enableNotification()">{{ 'request_push.enable' | translate }}</a>
  </div>
</div>
